export function timeZoneFun(value) {
    const easternStates = ["Connecticut", "Delaware", "Florida", "Georgia", "Indiana", "Kentucky", "Maine", "Maryland", "Massachusetts", "Michigan", "New Hampshire", "New Jersey", "New York", "North Carolina", "Ohio", "Pennsylvania", "Rhode Island", "South Carolina", "Vermont", "Virginia", "West Virginia", "District of Columbia"];
    
    const centralStates = ["Alabama", "Arkansas", "Illinois", "Iowa", "Kansas", "Louisiana", "Minnesota", "Mississippi", "Missouri", "Nebraska", "North Dakota", "Oklahoma", "South Dakota", "Tennessee", "Texas", "Wisconsin"];
    
    const mountainStates = ["Arizona", "Colorado", "Idaho", "Montana", "New Mexico", "Utah", "Wyoming"];
    
    const pacificStates = ["California", "Nevada", "Oregon", "Washington"];
    
    const alaskaState = ["Alaska"];
    
    const hawaiiState = ["Hawaii"];
    
    const usTerritoriesEastern = ["American Samoa", "Guam", "Puerto Rico", "U.S. Virgin Islands"];
    
    const usTerritoriesPacific = ["Northern Mariana Islands"];
    
    if (easternStates.includes(value)) {
        return 'Eastern';
    }
    if (centralStates.includes(value)) {
        return 'Central';
    }
    if (mountainStates.includes(value)) {
        return 'Mountain';
    }
    if (pacificStates.includes(value)) {
        return 'Pacific';
    }
    if (alaskaState.includes(value)) {
        return 'Alaska Time Zone';
    }
    if (hawaiiState.includes(value)) {
        return 'Hawaii-Aleutian Time Zone';
    }
    if (usTerritoriesEastern.includes(value)) {
        return 'Samoa Standard Time';
    }
    if (usTerritoriesPacific.includes(value)) {
        return 'Chamorro Standard Time';
    }
    return 'Unknown'; // If the state or territory is not found in any of the lists
}